import koodistoData from 'vtj-koodisto/src/vtj/static/autogenerated-koodisto.json'
import { KoodistoData } from 'vtj-koodisto/src/vtj/koodisto.type'

export const data = koodistoData as KoodistoData
